import FooterBlock from "../../components/Footer/Footer";
import GameCanvas from "./components/GameCanvas";
import LoggedOutView from "../LoggedOutPage/LoggedOutPage";
import { User as UserModel } from "../../models/user";
import Help from "./components/Help/Help";
interface GamePageProps {
  loggedInUser: UserModel | null;
}

const GamePage = ({ loggedInUser }: GamePageProps) => {
  return (
    <div className="startBellowNavbar pageBlock">
      {loggedInUser ? (
        <>
          <GameCanvas />
          <Help />
          <FooterBlock />
        </>
      ) : (
        <LoggedOutView />
      )}
    </div>
  );
};

export default GamePage;
